import CustomModalV2 from ".";

function CustomModalWrapper() {
    return (
        <div id="custom-modal-wrapper">
            <CustomModalV2/>
        </div>
    );
}

export default CustomModalWrapper;